import { useField } from "formik";
import {
  InputField,
  EfsMelcoEfsModelsFormat,
  SaveFormButton,
} from "melco-shared-logic";
import { Title } from "melco-ui";
import { useTranslation } from "react-i18next";
import { Attributes } from "./Attributes";

type ColorDataMappingProps = {
  inputFormat: EfsMelcoEfsModelsFormat;
};

export const ColorDataMapping: React.FC<ColorDataMappingProps> = ({
  inputFormat,
}) => {
  const { t } = useTranslation();

  const [{ value: type }] = useField("config_type");

  if (type !== "Color") {
    return null;
  }

  return (
    <>
      <InputField name="name" label={t("dataMappings.form.label.name")} />

      <Title level={5}>{t(`dataMappings.form.titles.color`)}</Title>

      <Attributes
        dataAssignments={inputFormat.schema_list ?? []}
        attribute="_color"
      />

      <SaveFormButton />
    </>
  );
};
